import React, { useState, useEffect } from "react";
import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import "./common.css";
import {
  AiTwotoneDelete,
  AiTwotoneEdit,
  AiTwotoneEye,
  AiOutlinePlusCircle,
} from "react-icons/ai";
import API_URL from "../common/Apiurl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SuccessMessage from "../common/Message";
import SearchBar from "material-ui-search-bar";
import ExportExcel from "../excelsheet/Excelexport";

function IncompleteUsers() {
  // new table
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [alldata, setAlldata] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [deleteconfirm, setDeleteconfirm] = useState([]);
  const [messagetext, setMessagetext] = useState("");
  const [successMessages, setSuccessMessages] = useState([]);
  const [searched, setSearched] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const getData = localStorage.getItem("user-info");
  const accessbility = JSON.parse(getData).data.accessbility;
  const handleOpen = (e, id, msgtext) => {
    setOpen(true);
    var setmsg = "";
    if (msgtext == "0") {
      setmsg = "Unblock";
    } else if (msgtext === 1) {
      setmsg = "block";
    } else if (msgtext === 2) {
      setmsg = "delete";
    }
    setMessagetext(setmsg);
    var dataArray = [id, setmsg];
    setDeleteconfirm(dataArray);
    console.log(dataArray);
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const getComments = async () => {
      try {
        const res = await fetch(`${apiUrl}/admin/incompleteuser`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        const data = await res.json();
        if (data.status !== 200) {
          throw new Error("Data not found");
        }
        setItems(data.data);
        setAlldata(data.data);
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  // get industry

  const deleteuser = async (e, id) => {
    e.preventDefault();
    setOpen(false);
    try {
      const posttodeleteData = {
        id: id[0],
        action_type: id[1],
      };
      const resultdelete = await fetch(`${apiUrl}/admin/deleteUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(posttodeleteData),
      });
      const deleteddata = await resultdelete.json();
      const newSuccessMessage = deleteddata.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
      if (deleteddata.status !== 200) {
        throw new Error("Data not found");
      }
    } catch (error) {
      console.log("Error: ", error);
    }
    // console.log(id);
  };
  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    window.location.reload();
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 535,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // new added
  var rows = items.sort((a, b) => (a.name < b.flag ? -1 : 1));
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // filtered
  const requestSearch = (searchedVal) => {
    var rows = alldata;
    const filteredRows = rows.filter((row) => {
      const restult1 = row.name.toLowerCase().includes(searchedVal.toLowerCase());
      if (!restult1) {
        return row.lastname.toLowerCase().includes(searchedVal.toLowerCase());
      } else {
        return restult1;
      }
    });
    if (filteredRows.length === 0) {
      setItems([]);
    } else {
      setItems(filteredRows);
    }
  };
  // filtered

  rows = items.sort((a, b) => (a.name < b.flag ? -1 : 1));

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
    const allRows = alldata;
    setItems(allRows);
  };
  rows = items.sort((a, b) => (a.name < b.flag ? -1 : 1));
  // new added

  const newArray = [];
  const itemsValue = items;
  itemsValue.map((dataItem, index) => {
    const newItem = {
      Number: index + 1,
      Name: dataItem.name,
      Lastname: dataItem.lastname,
      Email: dataItem.email,
    };
    newArray.push(newItem);
  });
  const ExcelExportData = newArray;

  return (
    <div className="width90">
      <div className="row">
        <div className="col-sm-9">
          <h2 className="pageTitle">Incomplete Users List</h2>
        </div>
      </div>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        className="mt-4"
      />
      {/* excelsheet */}
      <div className="form-group mt-3">
        <div className="row">
          <div className="col-sm-9"></div>
          <div className="col-sm-3 text-end">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Export Data
            </label>
            <ExportExcel
              excelData={ExcelExportData}
              fileName={"Incomplete Users"}
            />
          </div>
        </div>
      </div>
      {/* excelsheet */}
      {/* root */}
      <Root sx={{ maxWidth: "100%", width: 500 }}>
        <table aria-label="custom pagination table" className="cntr">
          <thead>
            <tr>
              <th>Name</th>
              <th>Lastname</th>
              <th>Email</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {(rowsPerPage > 0
              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rows
            ).map((row) => (
              // <tr key={row.category_name}>
              <tr>
                <td>{row.name}</td>
                <td>{row.lastname}</td>
                <td>{row.email}</td>
                <td style={{}} align="right">
                  {/* <Link to={`/admin/employers/viewemployer/${row.id}`} className='view'><AiTwotoneEye /></Link> */}
                  {accessbility?.incompleteusers.read === 1 ||
                  accessbility?.incompleteusers.read === true ? (
                    <Link
                      to={`/admin/incompleteusers/edituser/${row.id}`}
                      className="edit"
                    >
                      <AiTwotoneEdit />
                    </Link>
                  ) : null}
                  {accessbility?.incompleteusers.read === 1 ||
                  accessbility?.incompleteusers.read === true ? (
                    <button
                      type="button"
                      className="delete"
                      onClick={(e) => handleOpen(e, row.id, 2)}
                    >
                      <AiTwotoneDelete />
                    </button>
                  ) : null}
                </td>
              </tr>
            ))}
            {emptyRows > 0 && (
              <tr style={{ height: 41 * emptyRows }}>
                <td colSpan={6} aria-hidden />
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <CustomTablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                colSpan={6}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                slotProps={{
                  select: {
                    "aria-label": "rows per page",
                  },
                  actions: {
                    showFirstButton: true,
                    showLastButton: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </tr>
          </tfoot>
        </table>
      </Root>
      {/* root */}
      {/*  */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to {messagetext} this user?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              onClick={(e) => deleteuser(e, deleteconfirm)}
            >
              OK
            </Button>
            <Button
              variant="contained"
              onClick={handleClose}
              className="cancelbtn"
            >
              Cancel
            </Button>
          </Typography>
        </Box>
      </Modal>
      {/*  */}
      {successMessages.map((message, index) => (
        <SuccessMessage
          key={index}
          message={message}
          onFadeOut={handleSuccessMessageFadeOut}
        />
      ))}
    </div>
  );
}

const grey = {
  200: "#d0d7de",
  800: "#32383f",
  900: "#24292f",
};

const Root = styled("div")(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]};
    text-align: left;
    padding: 8px;
  }

  th {
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  }
  `
);

const CustomTablePagination = styled(TablePagination)`
  & .${classes.toolbar} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
  }

  & .${classes.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.spacer} {
    display: none;
  }

  & .${classes.actions} {
    display: flex;
    gap: 0.25rem;
  }
`;

export default IncompleteUsers;
